module.exports = __webpack_public_path__ + "static/media/comprehensive.b7051fef.svg";